import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { RootState } from '../..'
import { ToastOptions } from '@/src/ct-design/lib/Toast/type'

export interface NotificationState {
    message: string
    type: ToastOptions
    autoHide?: boolean // Add option to control auto-hiding
    duration?: number // Allow custom duration for specific notifications
}

const initialState: NotificationState = {
    message: '',
    type: 'ERROR',
    autoHide: true,
    duration: 5000 // Default 5 seconds
}

export const notificationSlice = createSlice({
    name: 'notification',
    initialState,
    reducers: {
        showNotification: (state, action: PayloadAction<NotificationState>) => {
            state.message = action.payload.message
            state.type = action.payload.type
            state.autoHide = action.payload.autoHide !== false // Default to true if not specified
            state.duration = action.payload.duration || 5000 // Use default if not specified
        },
        clearNotification: (state) => {
            state.message = ''
        }
    }
})

export const { showNotification, clearNotification } = notificationSlice.actions
export const getNotification = (state: RootState) => state.notification

export default notificationSlice.reducer
